import IconButton from "@mui/material/Button";
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {Button, DialogContent, FormControlLabel, FormGroup, TextField} from "@mui/material";
import * as React from "react";
import SettingsIcon from '@mui/icons-material/Settings';
import {useEffect, useState} from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import Checkbox from '@mui/material/Checkbox';
import InputLabel from "@mui/material/InputLabel";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {FxmsData} from "../../../datas/FxData";
import {TextBox_CemsDash001DataMart} from "../box/TextBox_CemsDash001DataMart";
import {CemsNetworkStatusDataMart} from "./CemsNetworkStatusDataMart";
import Divider from '@mui/material/Divider';
import { StyledEngineProvider } from "@mui/material/styles";
import Tooltip from '@mui/material/Tooltip';
import {AttrList} from "../../../datas/OpClass";

export const CemsNetworkStatus = (props) => {
    const [open, setOpen] = useState(false)
    const [api, setApi] = useState('')
    const [designOptions, setDesignOptions] = useState({
        title:'button',bgColor:'#2eb2c7',textColor:'#000000',
    })
    const [value, setValue] = useState(0);
    const [typeList, setTypeList] = useState([{name:'전체'},{name:'1차'},{name:'2차'},{name:'3차'},{name:'기타'}])
    const [selectedType, setSelectedType] = useState('전체')
    const [data, setData] = useState([])
    const [equipStatusList, setEquipStatusList] = useState([])
    const [selectedCompany, setSelectedCompany] = useState('')
    const saveCurrentData = () => {
        let currentData = []
        currentData.push({uiNo:props.item.uiNo,attrName:'api',attrVal:api,attrType:'string'})
        for(let key in designOptions){
            currentData.push({uiNo:props.item.uiNo,attrName:key,attrVal:designOptions[key]+'',attrType:'string'})
        }
        props.save(currentData,props.item.uiNo,props.item.opId)
    }
    useEffect(()=>{
        try {
            if(props.item.fxUiDashbItemAttrs){
                if(props.item.fxUiDashbItemAttrs.length >= 1 ){
                    setApi(props.item.fxUiDashbItemAttrs.find(x=>x.attrName =='api').attrVal)
                    let newOptions = {}
                    for(let key in designOptions){
                        newOptions[key] = props.item.fxUiDashbItemAttrs.find(x=>x.attrName==key).attrVal
                    }
                    setDesignOptions(newOptions)
                }
            }
        } catch (error) {
            console.log("error" + error);
        }
    },[])
    useEffect(()=>{
        if(api != ''){
            fetch(api).then((response)=>{
                return response.json()
            }).then(data=>{
                setData(data)
            })
        }
    },[api])
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const getEquipList = (id) => {
        setSelectedCompany(id)
    }
    const initEquipList = () => {
        setSelectedCompany(data[0]._3)
        fetch('http://175.123.142.155:11880/cemsCompanyNetworkEquips').then((response)=>{
            return response.json()
        }).then(datas=>{
            setEquipStatusList(datas)
        })

    }
    return (
        <StyledEngineProvider>
        <div>
            {props.editable ? <CemsNetworkStatusDataMart options={{designOptions,setDesignOptions}} api={setApi} handleCloseAndSave={saveCurrentData}/>: ''}
            <Button sx={{width:'100%',backgroundColor:designOptions.bgColor,color:designOptions.textColor}} onClick={()=>setOpen(true)} variant={"contained"}>
                {designOptions.title}
            </Button>
            <Dialog onClose={()=>setOpen(false)} open={open} >
                {designOptions.title}
                <Tabs sx={{right:'15px',position:'absolute','& .MuiTabs-flexContainer':{justifyContent:'end'},'& .Mui-selected':{color:'yellow!important'}}}  value={value} onChange={handleChange} >
                    <Tab label="사업장" sx={{color:'white'}} />
                    <Tab label="계측기" sx={{color:'white'}} onClick={initEquipList}/>
                </Tabs>
                <DialogContent>
                    <CustomTabPanel value={value} index={0}>
                        <div>
                            <FormControl sx={{m:'10px',minWidth:'300px'}}>
                                <InputLabel>사업장 분류</InputLabel>
                                <Select style={{color:'white'}}
                                        sx={{'& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'white'
                                            },
                                            '& .MuiSvgIcon-root': {
                                                color: 'white'
                                            }}}
                                        value={selectedType}
                                        onChange={(e)=>{setSelectedType(e.target.value)}}
                                >
                                    {typeList.map(x=>{
                                        return <MenuItem style={{color:'white'}} value={x.name}>{x.name}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        </div>
                        <Divider style={{backgroundColor:'white'}}/>
                        <div style={{overflow:'auto',height:'400px'}}>
                            {data.map(x=>{
                                return <Tooltip  componentsProps={{
                                    tooltip: {
                                        sx: {
                                            bgcolor: '#000000',
                                        },
                                    },
                                }} title={<h3 style={{backgroundColor:'#000000'}}>{x._3}</h3>} placement="right">
                                    <div onMouseOut={(e)=>{e.target.style.background=x._0 == "red"?'#999999':"#86e57f"}} onMouseOver={(e)=>{e.target.style.background="#10ff00"}}  style={{float:'left',overflow:'hidden',
                                        color:'black',margin:'10px',width:'140px', fontSize:'15px',textAlign:'center',display:'block',
                                        height:'28px',backgroundColor:x._0 == "red"?'#999999':"#86e57f"}}>{x._3}</div>
                                </Tooltip>
                            })}
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <div>
                            <FormControl sx={{m:'10px',minWidth:'300px'}}>
                                <InputLabel>사업장 목록</InputLabel>
                                <Select style={{color:'white'}}
                                        sx={{'& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'white'
                                            },
                                            '& .MuiSvgIcon-root': {
                                                color: 'white'
                                            }}}
                                        value={selectedCompany}
                                        onChange={(e)=>{getEquipList(e.target.value)}}
                                >
                                    {data.map(x=>{
                                        return <MenuItem style={{color:'white'}} value={x._3}>{x._3}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        </div>
                        <Divider style={{backgroundColor:'white'}}/>
                        <div style={{overflow:'auto',height:'400px'}}>
                            {equipStatusList.map(x=>{
                                return <div onMouseOut={(e)=>{e.target.style.background=x.status == "BAD"?'#999999':"#86e57f"}}
                                            onMouseOver={(e)=>{e.target.style.background="#10ff00"}}
                                    style={{float:'left',overflow:'hidden', color:'black',margin:'10px',width:'45%',
                                        fontSize:'15px',textAlign:'center',display:'block',lineHeight:'30px',
                                    height:'60px',backgroundColor:x.status == "BAD"?'#999999':"#86e57f"}}>
                                    {x.name}<br/>
                                    {x.info}
                                </div>
                            })}
                        </div>
                    </CustomTabPanel>
                </DialogContent>
            </Dialog>
        </div>
        </StyledEngineProvider>
    )
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}